import { makeAbsenceWarningRepository } from 'shared/infra/repositories';

import EvaluateAbsenceWarningUseCase from './implementations/EvaluateAbsenceWarningUseCase';

let instance: EvaluateAbsenceWarningUseCase | null = null;

export default function makeEvaluateAbsenceWarningUseCase() {
  if (!instance) {
    const absenceWarningRepository = makeAbsenceWarningRepository();

    instance = new EvaluateAbsenceWarningUseCase(absenceWarningRepository);
  }

  return instance;
}
